import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon, CalendarIcon } from 'lucide-react';
const navLinks = [{
  name: 'Leistungen',
  path: '/leistungen'
}, {
  name: 'Kieferorthopädie',
  path: '/kieferorthopaedie'
}, {
  name: 'Oralchirurgie',
  path: '/oralchirurgie'
}, {
  name: 'Team',
  path: '/team'
}, {
  name: 'Karriere',
  path: '/karriere'
}, {
  name: 'Blog',
  path: '/blog'
}];
export function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);
  return <>
      <header className={`fixed top-0 w-full z-50 transition-all duration-500 ${scrolled ? 'bg-weiss/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-123">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-124">
          <Link to="/" className="z-50 relative flex items-center" data-id="element-125">
            <img src="https://cdn.magicpatterns.com/uploads/pQ6AFtFVRrdrRb96QozNdU/hauptlogo.png" alt="edel & weiss Logo" className="h-10 w-auto object-contain" data-id="element-126" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-127">
            {navLinks.map(link => <Link key={link.path} to={link.path} className="text-sm font-medium text-schwarz hover:text-royal-blue transition-colors font-body" data-id="element-128">
                {link.name}
              </Link>)}
            <Link to="/kontakt" className="flex items-center space-x-2 bg-royal-blue text-weiss px-6 py-2.5 rounded-full text-sm font-medium hover:bg-royal-blue-dark transition-all hover:shadow-lg hover:-translate-y-0.5 border border-transparent hover:border-gold/50 font-body" data-id="element-129">
              <CalendarIcon className="w-4 h-4" data-id="element-130" />
              <span data-id="element-131">Termin vereinbaren</span>
            </Link>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden z-50 relative p-2 text-schwarz" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-132">
            {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-133" /> : <MenuIcon className="w-6 h-6" data-id="element-134" />}
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-135">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: '-100%'
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: '-100%'
      }} transition={{
        duration: 0.4,
        ease: [0.22, 1, 0.36, 1]
      }} className="fixed inset-0 z-40 bg-weiss pt-24 px-6 flex flex-col" data-id="element-136">
            <nav className="flex flex-col space-y-6 text-center mt-12" data-id="element-137">
              {navLinks.map(link => <Link key={link.path} to={link.path} className="text-2xl font-heading text-schwarz" data-id="element-138">
                  {link.name}
                </Link>)}
              <Link to="/kontakt" className="text-2xl font-heading text-royal-blue mt-4" data-id="element-139">
                Kontakt & Termine
              </Link>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </>;
}